/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InputText          from "./InputText.vue";
import GUI                from "services/gui";
import ApplicationState   from 'store/application';
import { XHR }            from 'utils/XHR';
import { t }              from 'g3w-i18n';

const __vue_script__ = {

  name: "changemapthemes",

  components: {
    InputText
  },

  props: {

    map_themes: {
      type: Object,
      default: { project: [], custom: [] }
    },

    layerstrees: {
      type: Array,
    },

  },

  data() {
    const theme = Object.values(this.map_themes).flat().find(mt => mt.default);
    return {
      active_theme: (theme && theme.theme) || null,
      collapsed:    'collapsed' === ApplicationState.project.state.toc_themes_init_status,
      // user themes
      custom_theme: {
        name:     'add-user-theme',
        label:    'sdk.catalog.choose_map_theme_input_label',
        i18nLabel: true,
        value:     null,
        editable:  true,
        type:      'varchar',
        input:    { type: 'text', options: {} },
        visible:  true,
        //@TODO add info messsage to validation input name text
        validate: {
          valid:    false,
          required: true,
          error: 'sdk.catalog.invalid_map_theme_name',
        }
      },
      /**@since 3.10.0 whether show add a new map theme form **/
      show_form: false,
    }
  },

  methods: {
    /**
     * @since 3.11.0
     */
    toggle() {
      //in case of no new form map_theme is show
      if (!this.show_form) {
        document.getElementById('g3w-catalog-views').classList.toggle('menu-open');
        this.collapsed = !this.collapsed;
      }
    },

    /**
     * Create params for save or update custom map theme
     * 
     * @private
     */
    _getMapThemeParams() {
      const params   = { layerstree: [], styles: {} };
      const traverse = (nodes, tree) => {
        nodes.forEach(node => {
          const item = undefined !== node.id
            ? {                                           // a layer node
              id:       node.id,
              name:     node.name,
              visible:  node.visible,
              expanded: node.expanded,
            }
            : {                                           // a group node
              name:                 node.name,
              checked:              node.checked,
              expanded:             node.expanded,
              'mutually-exclusive': node['mutually-exclusive']
            };
          // handle recursion (group node)
          if (Array.isArray(node.nodes)) {
            item.nodes = [];
            traverse(node.nodes, item.nodes);
          }
          // set style of layer
          if (undefined !== node.id) {
            params.styles[node.id] = node.styles.find(s => s.current).name; // get current layer style
          }
          tree.push(item);
        });
      };

      // loop through child nodes
      traverse(this.layerstrees[0].tree[0].nodes, params.layerstree);

      return params;
    },

    /**
     * Save current theme (layerstree state)
     * 
     * @since 3.10.0
     */
    async saveTheme() {
      const theme = this.custom_theme.value;
      // skip when no name provided 
      if (!theme) {
        return;
      }
      try {
        const params   = this._getMapThemeParams();
        const response = await XHR.post({
          url:         `${ApplicationState.project.urls.map_themes}${encodeURIComponent(theme)}/`,
          contentType: 'application/json',
          data:        JSON.stringify(params),
        });
        // handle server error
        if (!response.result) {
          throw response;
        }
        this.map_themes.custom.push({ theme: this.custom_theme.value, styles: params.styles });
        // show a success add custom matp theme message to user
        GUI.showUserMessage({ type: 'success', message: 'sdk.catalog.saved_map_theme', autoclose: true });
        // close dialog
        this.show_form    = false;
        //set as current active name map theme
        this.active_theme = this.custom_theme.value;
        //need to wait watch
        await this.$nextTick();
        //set custom map theme value to null. Reset value
        this.custom_theme.value = null;
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: e.error || 'info.server_error' });
      }
    },

    async updateTheme(theme) {
      // skip when no name provided
      if (!theme) {
        return;
      }
      try {
        const params   = this._getMapThemeParams();
        const response = await XHR.post({
          url:         `${ApplicationState.project.urls.map_themes}${encodeURIComponent(theme)}/`,
          contentType: 'application/json',
          data:        JSON.stringify(params),
        });
        // handle server error
        if (!response.result) {
          throw response;
        }
        // update custom map theme styles
        Object.assign(this.map_themes.custom.find(mt => theme === mt.theme), {
          styles:     params.styles,
          layerstree: params.layerstree,
        });
        // show a success update map theme message to user
        GUI.showUserMessage({ type: 'success', message: 'sdk.catalog.updated_map_theme', autoclose: true });
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: e.error || 'info.server_error' });
      }
    },

    /**
     * Remove map theme from custom themes
     * 
     * @param theme
     * 
     * @since 3.10.0
     */
    deleteTheme(theme) {
      GUI.dialog.confirm(t('sdk.catalog.question_delete_map_theme'), async bool => {
        // skip when ..
        if (!bool || !theme) {
          return;
        }
        try {
          const response = await (await fetch(`${ApplicationState.project.urls.map_themes}${encodeURIComponent(theme)}/`, {
            method: 'DELETE',
          })).json();
          // handle server error
          if (!response.result) {
            throw response;
          }
          this.map_themes.custom = this.map_themes.custom.filter(({ theme:t }) => t !== theme);
          // show a success message to user
          GUI.showUserMessage({ type: 'success', message: 'sdk.catalog.delete_map_theme', autoclose: true })
          // in the case of deleted current map theme set current theme to null
          if (theme === this.active_theme) { this.active_theme = null;}
        } catch(e) {
          console.warn(e);
          GUI.showUserMessage({ type: 'alert', message: e.error || 'info.server_error' });
        }
      });
    },

  },

  watch: {

    'active_theme': {
      immediate: false,
      handler(map_theme) {
        //in the case of save new custom map theme, no need to emit event
        //in case of remove custom map theme at moment se as default
        if (null === map_theme || map_theme === this.custom_theme.value) { return }
        this.$emit('change-map-theme', map_theme);
      }
    },

    'custom_theme.value'(name) {
      // can save check if value name is set and is not yet set on custom map_theme
      setTimeout(() => {
        this.custom_theme.validate.valid = name ? !this.map_themes.custom.find(({ theme }) => theme === name.trim()) : false;
      }, 200)

    },

    async show_form(bool) {
      this.custom_theme.value = null;
      // remove all "col-sm-12" classes so input is adapted to 100% width
      if (bool) {
        await this.$nextTick();
        Array.from(this.$refs.add_map_theme_input.$el.children).forEach(child => child.classList.remove('col-sm-12'));
      }
    },

  },

  created() {
    //set legged user.In the case of anonymous user, id is undefined and user can't save a custom map theme
    this.logged = undefined !== ApplicationState.user.id;
  }

}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sidebar-menu"},[_c('li',{staticClass:"treeview sidebaritem skin-border-color",attrs:{"id":"g3w-catalog-toc-views"}},[_c('a',{staticClass:"g3w-map-theme-anchor",attrs:{"href":"#"}},[_c('section',{on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_c('i',{class:_vm.$fa(_vm.collapsed ? 'caret-down' : 'caret-up'),staticStyle:{"padding":"3px"}}),_vm._v(" "),_c('i',{class:_vm.$fa(_vm.collapsed ? 'eye-close' : 'eye'),staticStyle:{"padding":"0 0 0 4px"}}),_vm._v(" "),(_vm.active_theme)?_c('span',{staticClass:"current_map_theme treeview-label g3w-long-text"},[_c('span',{directives:[{name:"t",rawName:"v-t:pre",value:('sdk.catalog.current_map_theme_prefix'),expression:"'sdk.catalog.current_map_theme_prefix'",arg:"pre"}]},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"skin-color",staticStyle:{"font-size":"1.1em"}},[_vm._v(_vm._s(_vm.active_theme))])]):_c('b',{directives:[{name:"t",rawName:"v-t",value:('sdk.catalog.choose_map_theme'),expression:"'sdk.catalog.choose_map_theme'"}],staticClass:"treeview-label"})])]),_vm._v(" "),(_vm.show_form)?_c('div',{staticClass:"add-map-theme skin-border-color"},[_c('div',{staticStyle:{"display":"flex","justify-content":"end","padding-top":"5px"}},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('close'),expression:"'close'",arg:"left",modifiers:{"create":true}}],staticClass:"sidebar-button sidebar-button-icon",class:_vm.$fa('close'),staticStyle:{"padding":"2px","margin":"2px"},on:{"click":function($event){$event.stopPropagation();_vm.show_form = false}}})]),_vm._v(" "),_c('div',{staticClass:"container add-map-theme-input"},[_c('input-text',{ref:"add_map_theme_input",attrs:{"state":_vm.custom_theme}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('add'),expression:"'add'"},{name:"disabled",rawName:"v-disabled",value:(!_vm.custom_theme.validate.valid),expression:"!custom_theme.validate.valid"}],staticClass:"sidebar-button-run btn btn-block",on:{"click":function($event){$event.stopPropagation();return _vm.saveTheme.apply(null, arguments)}}})])]):_c('ul',{class:{'menu-open': !_vm.collapsed},attrs:{"id":"g3w-catalog-views"}},[((_vm.map_themes.project || []).length > 0)?_c('li',{attrs:{"id":"g3w-catalog-views-project"}},[_c('ul',{staticStyle:{"padding":"0"}},[_c('li',[_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.catalog.project_map_theme'),expression:"'sdk.catalog.project_map_theme'"}],staticClass:"project_map_theme"})]),_vm._v(" "),_c('li',{staticStyle:{"padding":"5px 5px 5px 17px"}},_vm._l((_vm.map_themes.project),function(map_theme,i){return _c('div',{key:map_theme.theme},[_c('label',{attrs:{"for":("g3w-map_theme-" + i)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active_theme),expression:"active_theme"}],attrs:{"type":"radio","name":"radio","id":("g3w-map_theme-" + i)},domProps:{"value":map_theme.theme,"checked":_vm._q(_vm.active_theme,map_theme.theme)},on:{"change":function($event){_vm.active_theme=map_theme.theme}}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(map_theme.theme))])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.logged)?_c('li',{attrs:{"id":"g3w-catalog-views-user"}},[_c('ul',{staticStyle:{"padding":"0"}},[_c('li',[_c('div',{staticClass:"user_map_theme"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.catalog.user_map_theme'),expression:"'sdk.catalog.user_map_theme'"}]}),_vm._v(" "),_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('add'),expression:"'add'",arg:"left",modifiers:{"create":true}}],staticClass:"action sidebar-button sidebar-button-icon",class:_vm.$fa('plus'),staticStyle:{"margin-left":"auto","padding":"5px"},on:{"click":function($event){$event.stopPropagation();_vm.show_form = !_vm.show_form}}})])]),_vm._v(" "),_c('li',{staticStyle:{"padding":"5px 5px 5px 17px"}},_vm._l((_vm.map_themes.custom),function(map_theme,i){return _c('div',{key:map_theme.theme,staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',[_c('label',{attrs:{"for":("g3w-map_theme-" + i + "-user")}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active_theme),expression:"active_theme"}],attrs:{"type":"radio","name":"radio","id":("g3w-map_theme-" + i + "-user")},domProps:{"value":map_theme.theme,"checked":_vm._q(_vm.active_theme,map_theme.theme)},on:{"change":function($event){_vm.active_theme=map_theme.theme}}}),_vm._v(" "),_c('span',{staticClass:"g3w-long-text"},[_vm._v(_vm._s(map_theme.theme))])])]),_vm._v(" "),_c('span',{staticClass:"g3w-custom-map-theme-tools"},[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('update'),expression:"'update'",arg:"top",modifiers:{"create":true}},{name:"disabled",rawName:"v-disabled",value:(_vm.active_theme !== map_theme.theme),expression:"active_theme !== map_theme.theme"}],staticClass:"action sidebar-button sidebar-button-icon",staticStyle:{"padding":"5px"},on:{"click":function($event){$event.stopPropagation();return _vm.updateTheme(map_theme.theme)}}},[_c('i',{staticClass:"skin-color",class:_vm.$fa('save')})]),_vm._v(" "),_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top.create",value:('cancel'),expression:"'cancel'",arg:"top",modifiers:{"create":true}}],staticClass:"action sidebar-button sidebar-button-icon",staticStyle:{"padding":"5px"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTheme(map_theme.theme)}}},[_c('i',{class:_vm.$fa('trash'),staticStyle:{"color":"red"}})])])])}),0)])]):_vm._e()])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5f7ced52_0", { source: "#g3w-catalog-toc-views[data-v-5f7ced52]{margin-bottom:5px;border-bottom:2px solid}.g3w-map-theme-anchor[data-v-5f7ced52]{padding:0;margin-bottom:5px}.g3w-map-theme-anchor>section[data-v-5f7ced52]{display:flex;flex-wrap:wrap;align-items:center;padding:5px}.add-map-theme[data-v-5f7ced52]{border-top:2px solid;margin:5px 0}.add-map-theme-input[data-v-5f7ced52]{width:100%}#g3w-catalog-views[data-v-5f7ced52]{display:none;padding:0}#g3w-catalog-views.menu-open[data-v-5f7ced52]{display:block}.current_map_theme[data-v-5f7ced52]{overflow:hidden;white-space:normal;text-overflow:ellipsis}.project_map_theme[data-v-5f7ced52]{font-weight:700;padding:3px;border-bottom:1px solid #fff}.user_map_theme[data-v-5f7ced52]{font-weight:700;padding:5px 3px;display:flex;justify-content:space-between;align-self:baseline;border-bottom:1px solid #fff}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-5f7ced52"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CatalogChangeMapThemes.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__